import React, { useCallback, useContext, useEffect, useState } from 'react'
import { RateAndAccuracyLabel, WrapAccordion } from './Style'
import { useTheme } from 'styles'
import { useSelector } from 'react-redux'
import { isEmpty, keyBy, last, set } from 'lodash'
import { AccordionSummary } from '@mui/material'
import { prosodies } from 'keys'
import { Chip } from 'components/Form'
import { ratingColors, ratingColors3, ratingColors4, ratingColors5, ratingColors6 } from 'keys/rating'

const ReadingComprehension = () => {
    const { rating } = useSelector(state => state.rating)
    const { assessment } = useSelector(state => state.assessment)
    const { total_count, correct_count } = rating || {}
    const { Layout, Gutters } = useTheme()

    const incorrectCount = total_count - correct_count + 1

    const color = ratingColors5?.[incorrectCount] || last(ratingColors5)
    const bg = ratingColors6?.[incorrectCount] || last(ratingColors6)

    return (
        <div>
            <React.Fragment>
                <WrapAccordion>
                    <AccordionSummary
                        sx={{
                            ...Layout.fullHeight,
                            pointerEvents: "none"
                        }}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <div style={{ ...Layout.rowHCenter, ...Layout.justifyContentBetween, ...Layout.fullWidth }}>
                            <div style={{ ...Layout.rowHCenter, ...Layout.xlcGap }}>
                                {<RateAndAccuracyLabel>{"הבנת הנקרא"}</RateAndAccuracyLabel>}
                                {isEmpty(rating) ||
                                    <Chip color={color} bg={bg}>
                                        {correct_count}/{total_count}
                                    </Chip>
                                }
                            </div>
                        </div>
                    </AccordionSummary>
                </WrapAccordion>
            </React.Fragment>
        </div>
    )
}

export default ReadingComprehension